import { z } from 'zod';

import { request } from '@/api/httpClient';

export interface ClientOption {
  id: number;
  name: string;
}
export interface ClientGroup {
  id: number;
  name: string;
  clients: ClientOption[];
}
const groupSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  clients: z.array(z.object({ id: z.number().int().positive(), name: z.string() })).default([]),
});
export async function getGroups(): Promise<ClientGroup[]> {
  return z.array(groupSchema).parse(await request<unknown>('/managers/groups'));
}
export async function saveGroup(name: string, id?: number) {
  const response = await request<unknown>(`/managers/groups${id ? `/${id}` : ''}`, {
    method: id ? 'PUT' : 'POST',
    body: { name },
  });
  return groupSchema.parse(response);
}
export async function syncGroupClients(id: number, clientIds: number[]) {
  await request(`/managers/groups/${id}/sync-clients`, {
    method: 'POST',
    body: { client_ids: clientIds },
  });
}
export async function deleteGroup(id: number) {
  await request(`/managers/groups/${id}`, { method: 'DELETE' });
}
export async function sendGroupSms(message: string, groupId: number | null) {
  await request('/managers/group-sms', { method: 'POST', body: { message, group_id: groupId } });
}
